import { useMemo, forwardRef, useEffect,useRef } from 'react';
import { Link, useRouteMatch , useLocation} from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsIcon from '@material-ui/icons/Settings';
import ReportsIcon from '@material-ui/icons/Report';
import { makeStyles } from '@material-ui/core/styles';
import Report from '../pages/Report/Report';
import { SupervisedUserCircle, Print } from '@material-ui/icons';
import { color } from 'highcharts';
import { useLayoutCtx } from '@mui-treasury/layout';

const menus = [
    {
        label: 'Dashboard',
        icon: <DashboardIcon style={{  color: '#50c1e9' }} />,
        url: '/dashboard',
    },
   
    {
        label: 'Configuration',
        icon: <SettingsIcon style={{ backgroundColor: '#50c1e9', color: '#ffffff' }}/>,
        url: '/settings',
    },
    {
        label: 'Logs',
        icon: <Print style={{ backgroundColor: '#50c1e9', color: '#ffffff' }}/>,
        url: '/logs',
    },
    {
        label: 'Reports',
        icon: <ReportsIcon style={{ backgroundColor: '#50c1e9', color: '#ffffff' }}/>,
        url: '/reports',
    },
     {
        label: 'HelpDesk',
        icon: <DashboardIcon style={{  color: '#50c1e9' }} />,
        url: '/helpdesk',
    },
    {
        label: 'Asset Management',
        icon: <DashboardIcon style={{  color: '#50c1e9' }} />,
        url: '/assets',
    },
    {
        label: 'Users Management',
        icon: <SupervisedUserCircle style={{ backgroundColor: '#50c1e9', color: '#ffffff' }}/>,
        url: '/users_management',
    },

];

const useStyles = makeStyles({
    root: {
      '&$selected': {
        backgroundColor: '#d1eef7',
        '&:hover': {
            backgroundColor: '#a9cad540',
          }
      },
      '&:hover': {
        backgroundColor: '#a9cad540',
      },

    },
    selected: {},
  });

const PrivateNavContent = () => {
    const classes = useStyles();
    const { setOpen } = useLayoutCtx();
    const location = useLocation();
    const firstRender = useRef(true);

    // ✅ Close sidebar only AFTER the first route change
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        setOpen('primarySidebar', false);
    }, [location]);
    const ListItemLink = props => {
        const { icon, primary, to } = props;
        const match = useRouteMatch(to);
        const renderLink = useMemo(
            () =>
                forwardRef((linkProps, ref) => (
                    <Link ref={ref} to={to} {...linkProps} />
                )),
            [to],
        );

        return (    
            <ListItem
                button
                component={renderLink}
                selected={!!match}
                classes={{ root: classes.root, selected: classes.selected }}
                >
                {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                <ListItemText primary={primary}/>
            </ListItem>
        );
    };

    return (
        <>
            <List>
                {menus.map(({ label, icon, url }, index) => (
                    <li key={index}  >
                        <ListItemLink to={url} primary={label} icon={icon} />
                    </li>
                ))}
            </List>
        </>
    );
};

export default PrivateNavContent;
